const $ = jQuery;

const PopularSlider = {
	init: function () {
		$(document).ready(function () {
			const scrollBar = document.querySelector('.scroll-bar');
			const scrollThumb = document.createElement('div');
			const products = document.querySelector('.popular-products');
			if (products) {
				const allProducts = products.querySelectorAll('.product');

				if (window.innerWidth > 991) {
					if (!scrollBar || !products) return;

					scrollThumb.style.position = 'absolute';
					scrollThumb.style.height = '100%';
					scrollThumb.style.borderRadius = '20px';
					scrollThumb.style.backgroundColor = '#6c7564';
					scrollThumb.style.left = 0;
					scrollThumb.style.width = '30%';
					scrollThumb.style.transition = 'left 0.1s ease-out';
					if (allProducts.length > 4) scrollBar.appendChild(scrollThumb);

					function updateThumbWidth() {
						const ratio = products.clientWidth / products.scrollWidth;
						scrollThumb.style.width = `${ratio * 100}%`;
					}

					function syncThumbPosition() {
						const scrollRatio =
							products.scrollLeft /
							(products.scrollWidth - products.clientWidth);
						const maxLeft = scrollBar.clientWidth - scrollThumb.offsetWidth;
						scrollThumb.style.left = `${scrollRatio * maxLeft}px`;
					}

					products.addEventListener('scroll', syncThumbPosition);
					window.addEventListener('resize', updateThumbWidth);
					updateThumbWidth();

					let isDragging = false;
					let startX;
					let startLeft;

					scrollThumb.addEventListener('mousedown', (e) => {
						isDragging = true;
						startX = e.clientX;
						startLeft = parseFloat(scrollThumb.style.left);
						e.preventDefault();
					});

					window.addEventListener('mousemove', (e) => {
						if (!isDragging) return;
						const dx = e.clientX - startX;
						const maxLeft = scrollBar.clientWidth - scrollThumb.offsetWidth;
						let newLeft = startLeft + dx;
						newLeft = Math.max(0, Math.min(maxLeft, newLeft));
						scrollThumb.style.left = `${newLeft}px`;

						const scrollRatio = newLeft / maxLeft;
						products.scrollLeft =
							scrollRatio * (products.scrollWidth - products.clientWidth);
					});

					window.addEventListener('mouseup', () => {
						isDragging = false;
					});

					scrollBar.addEventListener('click', (e) => {
						if (e.target == scrollThumb) return;
						const rect = scrollBar.getBoundingClientRect();
						const clickX = e.clientX - rect.left;
						const ratio = clickX / scrollBar.clientWidth;
						products.scrollLeft =
							ratio * (products.scrollWidth - products.clientWidth);
					});
				}
			}
		});
	},
};

export default PopularSlider;
